
import Vue from 'vue';

import { Data as ArticleData } from '@root/modules/article/types/article';

interface Props {
  paymentInfo: ArticleData['content']['paywall']['attributes'];
  data: {
    isLoggedIn: boolean;
    profile: {
      displayName: string | null;
      id: number;
      email: string;
      firstName: string | null;
      lastName: string | null;
    };
  };
}

interface Computed {
  paywallUrl: string;
  paywallId: string;
}

interface Methods {
  getPaywallInfo: (e: any) => void;
}

interface Data {
  iframeHeight: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    paymentInfo: {
      type: Object,
      default: null,
      required: false,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      iframeHeight: '800px',
    };
  },
  computed: {
    paywallId() {
      const activeArticle = this.$store.getters['article/getActiveArticle'];
      return `paywall-${activeArticle.id}`;
    },

    paywallUrl() {
      const activeArticle = this.$store.getters['article/getActiveArticle'];
      return `https://www.delfi.lt/misc/plius/paywall.php?id=${activeArticle.id}`;
    },
  },
  mounted() {
    window.addEventListener('message', this.getPaywallInfo);
  },

  beforeDestroy() {
    window.removeEventListener('message', this.getPaywallInfo);
  },

  methods: {
    getPaywallInfo(event: MessageEvent) {
      if (typeof event.data === 'object' && event.data.type && event.data.type === 'paywallResize') {
        const height = event.data.value;
        const frame = this.$refs[this.paywallId] as HTMLIFrameElement;
        frame.style.height = `${Math.floor(height) + 50}px`;
      }
    },
  },
});
